/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useContext } from "react";
import AppContextInstance from "./AppContextInstance";
import IAppContext from "./IAppContext";

export interface AppContextProps {
    children: React.ReactNode;
}

const appContext = React.createContext({} as AppContextInstance);

export default function AppContext(props: AppContextProps) {
    const appContextInstance = new AppContextInstance();
    return <appContext.Provider value={appContextInstance}>{props.children}</appContext.Provider>;
}

export function useAppContext(): IAppContext {
    return useContext(appContext);
}
